<template lang="pug">
  .component-backoffice-category-list.row.column
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", ref="baseList")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'


export default {
  name: 'RequirementList',
  components: {
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/DocumentRequirement.vue'),
    }
  },
  created() {
  },
  methods: {
    reloadList() {
      this.$refs.baseList.loadData(1)
    },
    dataLoader(callback) {
      KeplerBackofficeSdk.documentRequirements.list().all((data) => {
        const items = data
        var tocs = {
          current_page: 1,
          current_page_count: 1,
          items: items,
          items_count: items.length,
          page_count: 1,
          per_page_count: 25,
        }
        callback(tocs)
      })
    },

  },
  props: ['entity_type', 'entity_id']
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentRequirementList.vue?410ecd96